import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useActionTermAndPolicy = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const openViewTermOfService =
    searchParams?.get("openViewTermOfService") || "false";
  const openViewPolicy = searchParams?.get("openViewPolicy") || "false";
  const openTerm = openViewTermOfService === "true";
  const openPolicy = openViewPolicy === "true";

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleOpenTerm = () => {
    setSearchParams({ openViewTermOfService: true });
  };

  const handleCloseTerm = () => {
    setSearchParams({});
  };

  const term = {
    handleOpen: handleOpenTerm,
    handleClose: handleCloseTerm,
    open: openTerm,
  };

  const handleOpenPolicy = () => {
    setSearchParams({ openViewPolicy: true });
  };
  const handleClosePolicy = () => {
    setSearchParams({});
  };

  const policy = {
    handleOpen: handleOpenPolicy,
    handleClose: handleClosePolicy,
    open: openPolicy,
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { term, policy };
};
